export default {
  title: 'MRR-raportti',
  fields: {
    name: 'Nimi',
    area: 'Alue',
    mrr: 'MRR (netto)',
  },
  buttons: {
    download_report: 'Lataa raportti',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui, päivitä sivu',
  },
};
